import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const FadeUp = ({ children, delay = 0, className = "", ...rest }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y: 28 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.15 }}
        transition={{ duration: 0.9, delay, ease: EASE }}
        {...rest}
    >
        {children}
    </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
    <motion.span
        className={`block overflow-hidden pb-[0.08em] -mb-[0.08em] ${className || ""}`}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.4 }}
    >
        <motion.span
            className="block will-change-transform"
            variants={{
                hidden: { y: "115%" },
                show: { y: 0, transition: { duration: 1.1, delay, ease: EASE } },
            }}
        >
            {children}
        </motion.span>
    </motion.span>
);

export { EASE };
